import { useState } from "react";
import { useStudentAuthContext } from "./useStudentAuthContext";
import API_URL from '../api/APIUrl';



export const useStudentLogin = () =>{
    const [error,setError] = useState(null);
    const [isLoading,setIsLoading] = useState(null);
    const {dispatch} = useStudentAuthContext();

    const studentLogin = async (email,password) => {
        setIsLoading(true);
        setError(null);

        try {
            const response = await fetch(API_URL.POST_STUDENT_LOGIN,{
                method: 'POST',
                headers: {'Content-Type' : 'application/json'},
                body: JSON.stringify({email,password})
            });
    
            const json = await response.json();
    
            if(!response.ok){
                setIsLoading(false);
                setError(json.error);
            }
    
            if(response.ok){
                //save the user to the local storage
                localStorage.setItem('studentuser',JSON.stringify(json));
                dispatch({type:'STUDENT_LOGIN',payload:json});
                setIsLoading(false);
            }
        } catch (error) {
            setError(error.message);
            setIsLoading(false);
        }

        
    }

    return {studentLogin, isLoading, error};
}